module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "report-root"
  }, [_c('general-title', {
    attrs: {
      "title": "客户端信息",
      "description": "帮助您了解访客访问您网站使用的客户端信息，在网站设计和优化时可以作为参考",
      "pos": "right",
      "date": _vm.timeSpan
    }
  }), _c('ul', {
    staticClass: "tab"
  }, _vm._l((_vm.dtTypes), function(tab) {
    return _c('li', {
      key: tab[1],
      staticClass: "tab-item"
    }, [_c('a', {
      staticClass: "tabview-btn",
      class: {
        active: _vm.dtType === tab
      },
      on: {
        "click": function($event) {
          _vm.dtType = tab
        }
      }
    }, [_vm._v(_vm._s(tab[1]))])])
  })), _c('timeSpan', {
    on: {
      "change": _vm.onTimespanChange
    }
  }), _c('div', {
    staticClass: "zone"
  }, [_c('TableTitle', {
    attrs: {
      "icon": "fa fa-signal",
      "title": "客户端信息分布图"
    }
  }), _c('hr', {
    staticClass: "header-chart-line"
  }), _c('RadioSquare', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curDimension),
      expression: "curDimension"
    }],
    staticStyle: {
      "margin-left": "30px",
      "font-size": "12px"
    },
    attrs: {
      "items": _vm.fluxDimensions
    },
    domProps: {
      "value": (_vm.curDimension)
    },
    on: {
      "input": function($event) {
        _vm.curDimension = $event
      }
    }
  }), _c('BarChart', {
    attrs: {
      "xAxis": _vm.fluxTrendXAxis,
      "valueAxis": _vm.valueAxis,
      "series": _vm.fluxTrendSeries,
      "tooltip": _vm.fluxTooltip,
      "dir": "vertical",
      "color": _vm.barColors,
      "loading": _vm.fluxLoading
    }
  })], 1), _c('div', {
    staticClass: "zone"
  }, [_c('TableTitle', {
    attrs: {
      "icon": "fa fa-list",
      "title": _vm.dtType[1] + '报表'
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fluxOriginList.length),
      expression: "fluxOriginList.length"
    }],
    staticClass: "download-btn"
  }, [_c('DownloadBtn', {
    attrs: {
      "reportApi": "/api/report/client",
      "pagetitle": _vm.dtType[1] + '报表',
      "params": _vm.downloadParams
    }
  })], 1), _c('CustomIndice', {
    attrs: {
      "defaults": _vm.defaultCustomIndices
    },
    on: {
      "change": _vm.onCustomIndiceChange
    }
  })], 1), _c('ComplexTable', {
    attrs: {
      "columns": _vm.columns,
      "list": _vm.fluxOriginList,
      "sum": {}
    }
  }), (_vm.total > _vm.ps) ? _c('v-pagination', {
    attrs: {
      "total": _vm.total,
      "pn": _vm.pg,
      "ps": _vm.ps
    },
    on: {
      "updatepage": _vm.updatePage
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-e55204b6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e55204b6!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pageview/web/client.vue
// module id = 806
// module chunks = 0